<template>
  <div class="empty">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState"
};
</script>

<style scoped lang="scss">
.empty {
  text-align: center;
  color: $colour-nhs-mid-grey;
  line-height: 1.2;
  padding: 10vh 0;

  a {
    color: $colour-nhs-mid-grey;
  }
}
</style>